require('../layout');
require("slick-carousel");


$("#welcome").find('.slide').slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    fade: false,
    prevArrow: $("#welcome").find(".arrows .prev"),
    nextArrow: $("#welcome").find(".arrows .next"),
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
            }
        },
        {
            breakpoint: 575,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
            }
        }
    ]
})